import { IAdClient } from '@/bundles/Ad/interfaces';
import BaseModel from '@/bundles/App/models/BaseModel';

export default class AdClient extends BaseModel implements IAdClient {
  active: boolean;
  name: string;

  constructor (props: IAdClient) {
    super(props);
    this.active = props.active;
    this.name = props.name;
  }
}
